import { AlarmHornStrobeAnimatic } from '@crossnokaye/ux-animatics';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticAlarmStrobe = ({
  labels,
  state,
  className,
}: Omit<AnimaticConfigProps, 'config'>) => {
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <AlarmHornStrobeAnimatic label={primaryLabel?.text} state={state} />
    </ScaledAnimatic>
  );
};
